import { auth } from './firebase'
import { GoogleAuthProvider, signInWithPopup, signOut as firebaseSignOut } from 'firebase/auth'
import { useAuthStore } from '../stores/auth'

export type OAuthProvider = 'google' | 'github'

export function getAuthToken(): string | null {
  const authStore = useAuthStore()
  return authStore.token
}

// Mock better-auth client so other components don't crash
export const authClient = {
  getSession: async () => ({ data: { user: auth.currentUser, session: { id: auth.currentUser?.uid } } }),
  listSessions: async () => ({ data: [] }),
}

let initialized = false

export async function initializeAuth() {
  if (initialized) return
  initialized = true
  // Firebase auto-initializes via onAuthStateChanged in stores/auth.ts
}

export async function fetchSession() {
  const authStore = useAuthStore()
  return authStore.isAuthenticated
}

export async function listSessions() {
  return []
}

export async function signOut() {
  await firebaseSignOut(auth)
}

export async function signInOIDC(params: any) {
  const provider = new GoogleAuthProvider()
  try {
    await signInWithPopup(auth, provider)
  } catch (error) {
    console.error('Login failed', error)
  }
}

export async function applyOIDCTokens(tokens: any, clientId: string) {}

export async function triggerSignIn(opts?: { provider?: OAuthProvider }): Promise<void> {
  const provider = new GoogleAuthProvider()
  try {
    await signInWithPopup(auth, provider)
  } catch (error) {
    console.error('Login failed', error)
  }
}
